import Image, { type ImageProps, type StaticImageData } from 'next/image';

import {
  Box,
  Container,
  type ContainerProps,
  Stack,
  Typography,
  type TypographyProps,
} from '@mui/material';

import { sizes } from '@client/constants/sizes';

export default (props: {
  title?: string | React.ReactNode;
  imageSrc?: string | StaticImageData;
  imageAlt?: string;
  body?: React.ReactNode | React.ReactNode[] | string;
  buttons?: React.ReactNode | React.ReactNode[];
  titleProps?: TypographyProps;
  imageProps?: Partial<ImageProps>;
  containerProps?: Partial<ContainerProps>;
}) => (
  <Container
    maxWidth={'md'}
    sx={{
      width: '100%',
      height: '100%',
      maxHeight: `calc(100% - ${sizes.navBarHeight})`,
    }}
    {...props.containerProps}>
    <Stack spacing={3} sx={{ height: '100%' }}>
      {typeof props.title !== 'string' && <>{props.title}</>}
      {typeof props.title === 'string' && (
        <Typography align='center' variant='h2' color='primary' {...props.titleProps}>
          {props.title}
        </Typography>
      )}

      {props.imageSrc && (
        <Box sx={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
          <Image
            src={props.imageSrc}
            alt={props.imageAlt ?? ''}
            width={326}
            height={247}
            priority
            {...props.imageProps}
          />
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          height: '100%',
          width: '100%',
        }}>
        {typeof props.body == 'string' && (
          <Typography align='center' variant='body1'>
            {props.body}
          </Typography>
        )}
        {typeof props.body !== 'string' && <>{props.body}</>}
      </Box>
      {props.buttons && (
        <>
          <Stack direction='row' spacing={2} justifyContent='center' sx={{ width: '100%' }}>
            {props.buttons}
          </Stack>
        </>
      )}
    </Stack>
  </Container>
);
